const S3_PROXY_BASE = (
  process.env.REACT_APP_S3_PROXY_URL ||
  process.env.REACT_APP_API_URL ||
  (typeof window !== 'undefined' ? window.location.origin : 'https://procureright.in')
).replace(/\/$/, '');

export const S3_BUCKET_BASE = 'https://procureright2.s3.ap-south-1.amazonaws.com';
export const TRP_PLACEHOLDER_IMAGE = '/trplogo.png';

const LEGACY_S3_HOSTS = [
  'procureright1.s3.ap-south-1.amazonaws.com',
  'procureright1.s3.amazonaws.com',
  'procureright2.s3.ap-south-1.amazonaws.com',
  'procureright2.s3.amazonaws.com',
  'procurerighttrp.s3.amazonaws.com',
  'procurerighttrp.s3.ap-south-1.amazonaws.com',
  'procurerighttrp.s3.ap-southeast-1.amazonaws.com',
];

function extractS3Key(value) {
  const cleaned = String(value || '').trim().replace(/^["']+|["']+$/g, '');
  if (!cleaned) return '';

  if (!/^https?:\/\//i.test(cleaned)) {
    return cleaned.replace(/^\//, '');
  }

  for (const host of LEGACY_S3_HOSTS) {
    const marker = `${host}/`;
    const idx = cleaned.indexOf(marker);
    if (idx !== -1) {
      return cleaned.substring(idx + marker.length).split('?')[0];
    }
  }

  const match = cleaned.match(/amazonaws\.com\/(.+?)(?:\?|$)/i);
  return match ? match[1] : cleaned.replace(/^https?:\/\/[^/]+\//, '');
}

function buildProxyUrl(key) {
  const base = S3_PROXY_BASE;
  if (base.includes('procureright.in') && !base.includes('buyer.')) {
    return `${base}/api/s3-image?key=${encodeURIComponent(key)}`;
  }
  if (base.includes('/milestone-api')) {
    return `${base}/api/products/s3-image?key=${encodeURIComponent(key)}`;
  }
  return `${base}/milestone-api/api/products/s3-image?key=${encodeURIComponent(key)}`;
}

export function resolveS3ImageUrl(value) {
  if (!value) return TRP_PLACEHOLDER_IMAGE;

  const key = extractS3Key(value);
  if (!key || key === 'undefined') return TRP_PLACEHOLDER_IMAGE;

  return buildProxyUrl(key);
}

export function onS3ImageError(event) {
  if (!event?.target) return;
  event.target.onerror = null;
  event.target.src = TRP_PLACEHOLDER_IMAGE;
}

export const BaseUrl = '';
